<div class="info-box_container">
  <div class="info-box_button" (click)="onClose.emit()">
    <i class="fa fa-times"></i>
  </div>
  {{message}}
</div>
